import i18nFactory from '@yandex-int/i18n';

import { OfficeContact, OfficeInfo } from '../../typings/common';

import * as keyset from './footer.i18n';

const i18n = i18nFactory(keyset);

export interface Actions {
    title: string;
    links: Array<{
        text: string;
        href: string;
        isPureRoute: boolean;
        isBeta?: boolean;
    }>;
    isPureRoute?: boolean;
}

export function mapApiContact(
    contact: OfficeContact,
    defaultCity: string
): {
    name: string;
    tel?: string;
} {
    let phoneExtension;

    if (contact.phoneExtension) {
        phoneExtension = i18n('phone-extension', {
            phone: contact.phoneExtension
        });
    }

    return {
        name: contact.cityName || defaultCity,
        tel: [contact.phone, phoneExtension, contact.description].filter(el => el).join(' ')
    };
}

export function getContacts(
    officeInfo: OfficeInfo
): Array<
    | {
          name: string;
          tel?: string;
      }
    | undefined
> {
    return [
        officeInfo.cityContact && mapApiContact(officeInfo.cityContact, i18n('moscow')),
        ...officeInfo.regionContacts.map((contact, index) => mapApiContact(contact, index === 0 ? i18n('regions') : ''))
    ];
}
